export const API_STAGE_MAP: Record<string, string> = {
  ['test']: 'alpha',
  ['beta']: 'alpha',
};

export const SUBMIT_INTEREST_API_NAME: string = 'interest';

export const UNKNOWN_PARTNER: string = 'UNKNOWN';
